import { IoAlertOutline } from "react-icons/io5";
import { FiCreditCard, FiLock } from "react-icons/fi";
import { mascaraMoeda, maskCurrency, TypePayment } from "../../../utils/utils";
import { Toast } from "../../../utils/Toast";
import { api } from "../../../api/api";
import { useState } from "react";

let isRequest = false

const DEFAULT_INFO = {
  [TypePayment.card_credit]: 0,
  [TypePayment.card_debit]: 0,
  [TypePayment.money]: 0,
  [TypePayment.pix]: 0,
  [TypePayment.ifood]: 0,
}

const PAYMENT_FIELDS = [
  [TypePayment.money, 'Dinheiro'],
  [TypePayment.card_credit, 'Cartão de crédito'],
  [TypePayment.card_debit, 'Cartão de débito'],
  [TypePayment.pix, 'PIX'],
  [TypePayment.ifood, 'iFood'],
]

export function ModalCloseSafe({ reload }) {
  const [info, setInfo] = useState(DEFAULT_INFO)

  async function closeSafe() {
    try {
      const confirmation = await Toast.confirm("Você confirma, que quer fechar o caixa?", 'Não', 'Sim')
      if (confirmation) {

        if (isRequest) {
          return Toast.warning('Aguarde um momento, estamos salvando a informação.')
        }

        isRequest = true
        await api.post('/safe/close', { info })
        isRequest = false
        await reload()
        setInfo(DEFAULT_INFO)
        Toast.success()
        document.getElementById('close-modal-safe').click()
      }
    } catch (error) {
      isRequest = false
    }
  }
  return (
    <div className="modal fade admin-form-modal safe-close-modal" id="modalCloseSafe" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modalCloseSafeLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="safe-modal-heading"><span><FiLock /></span><div><h5 className="modal-title" id="modalCloseSafeLabel">Fechar caixa</h5><p>Confira e declare os valores recebidos</p></div></div>
            <button type="button" id="close-modal-safe" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="safe-close-notice" role="alert"><IoAlertOutline /><div><strong>Valores declarados</strong><span>Informe o total recebido em cada finalizadora.</span></div></div>
            <div className="safe-close-fields">
              {PAYMENT_FIELDS.map(([type, label]) => <label key={type} htmlFor={`safe-close-${type}`}><span><FiCreditCard /> {label}</span><input id={`safe-close-${type}`} type="text" value={maskCurrency(info[type])} onChange={(event) => setInfo({ ...info, [type]: mascaraMoeda(event.target.value) })} inputMode="decimal" /></label>)}
            </div>
            <label className="safe-close-observation" htmlFor="safe-close-observation"><span>Observação</span><textarea id="safe-close-observation" rows="3" placeholder="Informação opcional para conferência" /></label>
            <div className="safe-modal-actions"><button className="safe-close-confirm-button" onClick={() => closeSafe()}><FiLock /> Fechar caixa</button></div>
          </div>
        </div>
      </div>
    </div>
  )
}
